<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 mat-dialog-title>
  <span i18n="@@rPFormTitleCreate" *ngIf="!isModeEdit">Create a new removal point</span>
  <span i18n="@@rPFormTitleModify" *ngIf="isModeEdit">Edit removal point</span>
</h4>

<div mat-dialog-content>
  <form [formGroup]="removalPointFG" #rpForm="ngForm" (ngSubmit)="removalPointFormSubmit()" autocomplete="off">
    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-name controlName="name" [formGroup]="removalPointFG"
                        [submitted]="rpForm?.submitted"></app-input-name>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-address controlName="address" [formGroup]="removalPointFG"
                           [submitted]="rpForm?.submitted"></app-input-address>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-address controlName="address2" i18n-label="@@address2" label="Address 2" [formGroup]="removalPointFG"
                           [readonly]="true" [showRequired]="false" showValidation="no"
                           [submitted]="rpForm?.submitted"></app-input-address>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-township controlName="township" [formGroup]="removalPointFG" [readonly]="isModeEdit"
                            [submitted]="rpForm?.submitted"></app-input-township>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-phone-numbers [removalPoint]="rp" [allowAdd]="true" [allowRemove]="true"
                                 [needData]="!hasPhoneNumbers" [showRequired]="true" showValidation="submitted"
                                 [submitted]="rpForm?.submitted"
                                 (updated)="updatePhones($event)"></app-input-phone-numbers>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-phone-numbers [removalPoint]="rp" [mobilePhones]="true" [allowAdd]="true" [allowRemove]="true"
                                 [needData]="!hasPhoneNumbers" [showRequired]="true" showValidation="submitted"
                                 [submitted]="rpForm?.submitted"
                                 (updated)="updatePhones($event)"></app-input-phone-numbers>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
        <p class="font-light text-muted" i18n="@@required">* Mandatory</p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <p class="font-light text-muted" i18n="@@phonesRequired">** At least a phone number is required</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
        <button class="btn btn-danger btn-rounded btn-block" type="button" (click)="cancel($event)" i18n="@@cancel">
          Cancel
        </button>
      </div>

      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
        <button class="btn btn-success btn-rounded btn-block" type="submit">
          <span i18n="@@create" *ngIf="!isModeEdit">Create</span>
          <span i18n="@@modify" *ngIf="isModeEdit">Modify</span>
        </button>
      </div>
    </div>
  </form>
</div>
